import { render, staticRenderFns } from "./LobbyHostingHelp.vue?vue&type=template&id=47ce3fc9&scoped=true"
import script from "./LobbyHostingHelp.vue?vue&type=script&lang=js"
export * from "./LobbyHostingHelp.vue?vue&type=script&lang=js"
import style0 from "./LobbyHostingHelp.vue?vue&type=style&index=0&id=47ce3fc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce3fc9",
  null
  
)

export default component.exports